import { defineMessages } from 'react-intl';

export const messages: {
	lastModified: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	lastModified: {
		id: 'search-result.last-modified',
		defaultMessage: 'Updated {formattedDate}',
		description: 'This shows the timestamp of when the result was last modified.',
	},
});
